import { Box, List } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import { clsx } from "clsx";
import { useLocation } from "react-router-dom";
import ListItemCustom from "./ListItemCustom";
import MenuItems from "./menu";
import PersonalMenuItems from "./menu-personal";
import styles from "./styles.module.scss";

const menuShowWidth = "256px";
const leftMenuWeb = "16px";
const gap2Top = "104px";
const menuHideWidth = "72px";

const LeftMenu = () => {
  const location = useLocation();
  const { pathname } = location;

  const isIncludeSubPath = (subPathList: string[]) => {
    let result = false;
    subPathList.forEach((s) => {
      if (pathname.includes(s)) result = true;
    });
    return result;
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: menuShowWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          paddingTop: gap2Top,
          width: menuShowWidth,
          fontSize: leftMenuWeb,
          backgroundColor: "#1B1B1B"
        }
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: "column",
          height: "100%"
        }}
      >
        <List className={styles.list}>
          {MenuItems.map((item) => (
            <ListItemCustom
              key={item.path}
              item={item}
              className={clsx(styles.listItem, {
                [styles.active]:
                  item.path !== "" &&
                  (pathname.includes(item.path) ||
                    isIncludeSubPath(item.subPath)) &&
                  !item.strokeIcon,
                [styles.activeStroke]:
                  item.path !== "" &&
                  (pathname.includes(item.path) ||
                    isIncludeSubPath(item.subPath)) &&
                  item.strokeIcon
              })}
            />
          ))}
        </List>
      </Box>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: "column",
          height: "100%"
        }}
      >
        {/* <List className={`${styles.list} ${styles.personalList}`}>
          {PersonalMenuItems.map((item) => (
            <ListItemCustom
              key={item.path}
              item={{ ...item, isPersonalItem: true }}
              className={clsx(styles.listItem)}
            />
          ))}
        </List> */}
      </Box>
    </Drawer>
  );
};

export default LeftMenu;
